import React, { useEffect } from "react";
import { HeaderCount, HeaderIcon, HeaderTitle, HeaderTitleLeftContainer, HeaderTitleRightContainer, HeaderWrapper, StyledCircleButton } from "./styles";
import { useAppSelector } from "../../../../../utils/hooks/redux";
import { CloseOutlined } from "@ant-design/icons";
import { Form } from "antd";
import { LostStatuses } from "../../../../../types/LostStatuses";
import { ReportType } from "../../../../../redux/features/board/columnTypes";
import SystemPayRoutes from "../../../../../utils/constants/Routes";
import { useNavigate } from "react-router-dom";

interface HeaderProps {
  title: string;
  icon: any;
  count: number;
  status: number;
  closable: boolean;
  /** Optional override (used by Review column to flip between amber/green by majority). */
  colorOverride?: string | null;
}

const ColumnHeader: React.FC<HeaderProps> = ({ title, icon, count, status, closable, colorOverride }) => {
  const initReportType = useAppSelector((state) => state.columns.initReportType);
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const handleClickOnHeader = (e: React.MouseEvent) => {
    const target = e.target as HTMLElement;
    // Prevent triggering navigation when clicking on input or button
    if (
      target.closest("input") ||
      target.closest("button") ||
      target.closest(".ant-input") ||
      target.closest(".ant-btn")
    ) {
      return;
    }

    e.stopPropagation();
    !closable && navigate(`${SystemPayRoutes.reports}/lost/${status}`);
  };

  useEffect(() => {
    form.setFieldValue("title", title)
  }, [form, title])

  return (
    <HeaderWrapper
      onClick={(e) => handleClickOnHeader(e)}
      className="columnHeader"
    >
      <HeaderTitleLeftContainer>
        <HeaderIcon $status={status} $colorOverride={colorOverride}>{icon}</HeaderIcon>
        <HeaderTitle $status={status} $colorOverride={colorOverride}>{title}</HeaderTitle>
        {status !== LostStatuses.Deleted && <HeaderCount $status={status} $colorOverride={colorOverride}>{count}</HeaderCount>}
      </HeaderTitleLeftContainer>
      <HeaderTitleRightContainer>
        {initReportType !== ReportType.Found && ![LostStatuses.Deleted].includes(status) && closable && <StyledCircleButton icon={<CloseOutlined />} shape="circle" onClick={(e) => {
          e.stopPropagation();
          navigate(`${SystemPayRoutes.reports}`);
        }} />}
      </HeaderTitleRightContainer>
    </HeaderWrapper>
  );
};

export default ColumnHeader;
